<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize ',
        $store.getters[this.getter].countryTargetGroups.length > 0
          ? 'selected'
          : ''
      ]"
      @click="fieldData.showCountryTargetModal = true"
    >
      Country of production / Main target group
    </button>
    <b-modal
      @ok="saveCountryTargetGroups"
      @show="showModal"
      @hide="onHidden"
      v-model="fieldData.showCountryTargetModal"
      title="Country of production / Main target group"
      :no-close-on-backdrop="true"
    >
      <div class="form-row">
        <div class="col-sm-6">
          <label>Country of production</label>
          <b-form-select
            size="sm"
            :options="productionCountryOptions"
            v-model="selectedProductionCountry"
          ></b-form-select>
        </div>
        <div class="col-sm-6">
          <label>Main target group</label>
          <b-form-select
            size="sm"
            :options="mainTargetGroupOptions"
            v-model="selectedMainTargetGroup"
          ></b-form-select>
        </div>
        <div class="col-sm-12">
          <b-button
            variant="success btn-sm"
            class="my-4"
            :disabled="
              selectedMainTargetGroup == null &&
                selectedProductionCountry == null
            "
            @click="addCountryTargetGroup"
          >
            Add
          </b-button>
          <b-button
            @click="removeCountryTargetGroups"
            v-if="temporaryCountryTargetGroups.length > 1"
            class="my-4 ml-2"
            variant="danger"
            size="sm"
            >Remove all</b-button
          >
        </div>
        <b-list-group class="col-sm-12">
          <b-list-group-item
            v-bind:key="index"
            v-for="(item, index) in temporaryCountryTargetGroups"
          >
            <span>{{ stringifyCountryTargetGroup(item) }}</span>
            <b-button
              v-on:click="removeCountryTargetGroup(index)"
              class="ml-2 float-right"
              variant="danger"
              size="sm"
              >Remove
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import props from "@/mixins/inputProps";
export default {
  name: "CountryTargetBubble",
  mixins: [props],
  data() {
    return {
      selectedMainTargetGroup: null,
      mainTargetGroupOptions: [
        { value: null, text: "Choose an option" },
        { value: "V", text: "Adult" },
        { value: "B", text: "Child/Youth" }
      ],
      selectedProductionCountry: null,
      productionCountryOptions: [
        { value: null, text: "Choose an option" },
        { value: "S", text: "Swedish" },
        { value: "U", text: "Foreign" }
      ],
      temporaryCountryTargetGroups: []
    };
  },
  computed: {
    getButtonText() {
      let btnText = `Country of production / Main target group `;
      let numberOfStoredCountryTargets = this.$store.getters[this.getter][
        this.fieldData.identifier
      ].length;
      btnText += `${numberOfStoredCountryTargets} selected`;
      return btnText;
    }
  },
  methods: {
    onHidden() {
      document.removeEventListener("keyup", this.onKeyUp);
    },
    showModal() {
      document.addEventListener("keyup", this.onKeyUp);
      this.temporaryCountryTargetGroups = [
        ...this.$store.getters[this.getter][this.fieldData.identifier]
      ];
    },
    addCountryTargetGroup() {
      let newCountryTargetGroup = {
        mainTargetGroup: this.selectedMainTargetGroup,
        productionCountry: this.selectedProductionCountry
      };
      let alreadyAdded =
        this.temporaryCountryTargetGroups.filter(
          t =>
            t.mainTargetGroup === newCountryTargetGroup.mainTargetGroup &&
            t.productionCountry === newCountryTargetGroup.productionCountry
        ).length !== 0;
      if (alreadyAdded) {
        this.$bvToast.toast("Country of production / Main target group already exists", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }
      this.selectedMainTargetGroup = null;
      this.selectedProductionCountry = null;
      this.temporaryCountryTargetGroups.push(newCountryTargetGroup);
    },
    stringifyCountryTargetGroup(item) {
      let stringifiedCountryTargetGroups = [];
      if (item.productionCountry)
        stringifiedCountryTargetGroups.push(
          this.productionCountryOptions.find(
            t => t.value === item.productionCountry
          ).text
        );
      if (item.mainTargetGroup)
        stringifiedCountryTargetGroups.push(
          this.mainTargetGroupOptions.find(
            t => t.value === item.mainTargetGroup
          ).text
        );

      return stringifiedCountryTargetGroups.join(" and ");
    },
    removeCountryTargetGroups() {
      this.temporaryCountryTargetGroups = [];
    },
    removeCountryTargetGroup(index) {
      this.temporaryCountryTargetGroups.splice(index, 1);
    },
    saveCountryTargetGroups() {
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        [this.fieldData.identifier]: this.temporaryCountryTargetGroups
      };
      return this.$store.commit(this.setter, updatedQuery);
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showCountryTargetModal) {
        this.saveCountryTargetGroups();
        this.fieldData.showCountryTargetModal = false;
      }
    }
  }
};
</script>
